import MarkdownView from './markdown_view';

export default MarkdownView;
